export default __webpack_public_path__ + "static/media/group-578@2x.7fa30765.png";